import { Box, useMediaQuery } from "@mui/material";
import ContactUsSectionComponent from "../component/landing/contact-us-section.component";
import { useEffect } from "react";
const ContactScreen = () => {

    const isSmallScreen = useMediaQuery('(max-width:600px)');
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Box className={`${isSmallScreen ? "container-fluid container-xxxl" : ""}`} sx={{ padding: 0, mt: 8 }} >
            <ContactUsSectionComponent />
        </Box>
    )
}

export default ContactScreen;
